import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTracker } from '@dpdgroupuk/react-event-tracker';

import SectionList from '../../../components/LeftMenu/components/SectionComponents/SectionList';
import useLocationQueryParams from '../../../hooks/useLocationQueryParams';
import { stringifyQuery } from '../../../utils/query';
import { ROUTES_PAGE, SECTION_FULL_PAGE } from '../../../constants/routes';
import { SECTIONS } from '../../../constants/analytics';
import useAsyncNavigate from '../../../hooks/useAsyncNavigate';

const SectionListContainer = () => {
  const query = useLocationQueryParams();
  const navigate = useAsyncNavigate();
  const location = useLocation();
  const tracker = useTracker();
  const [selectedSection, setSelectedSection] = useState(query?.sectionId);
  const [selectedSectionView, setSelectedSectionView] = useState(
    location.pathname
  );

  useEffect(() => {
    tracker.logEvent(SECTIONS.LOAD);
  }, [tracker]);

  const onTabChange = useCallback(
    async (e, value) => {
      await navigate({
        pathname: value,
        search: location.search,
      });
      setSelectedSectionView(value);

      tracker.logEvent(
        SECTIONS[
          value === SECTION_FULL_PAGE ? 'SELECT_STATS_VIEW' : 'SELECT_LIST_VIEW'
        ]
      );
    },
    [navigate, location.search, tracker]
  );

  const onSectionClick = useCallback(
    (sectionCode) => {
      setSelectedSection(sectionCode);
      tracker.logEvent(SECTIONS.CLICK_SECTION);
    },
    [tracker]
  );

  const onSectionDoubleClick = useCallback(
    async (sectionId) => {
      await navigate({
        pathname: ROUTES_PAGE,
        search: stringifyQuery({
          ...query,
          sectionId,
        }),
      });

      tracker.logEvent(SECTIONS.DOUBLE_CLICK_SECTION);
    },
    [navigate, query, tracker]
  );

  return (
    <SectionList
      onTabChange={onTabChange}
      onSectionClick={onSectionClick}
      onSectionDoubleClick={onSectionDoubleClick}
      selectedSection={selectedSection}
      selectedSectionView={selectedSectionView}
    />
  );
};

export default SectionListContainer;
